import { gangtokInstance as http } from "./http-common";

const token = JSON.parse(localStorage.getItem("token"));

const getRangpoTollCollection = (data) => {
  return http.post("TollCollection/GetTollCollection", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const RangpoService = {
  getRangpoTollCollection,
};

export default RangpoService;
